import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { HeaderLink } from '../Interfaces';
import KeyboardArrowIcon from './KeyboardArrowIcon';
import styles from '../Header.styles';

const BottomBarMenuItem = ({
  index,
  label,
  url,
  externalUrl,
  subLinks,
  onClick,
  isActive,
}: HeaderLink) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id={`basic-button-${index}`}
        aria-haspopup={subLinks !== undefined && subLinks?.length > 0}
        aria-expanded={open ? 'true' : undefined}
        onClick={(e: React.MouseEvent<HTMLElement>) => {
          if (onClick) onClick(e);
          handleClick(e);
        }}
        {...{
          href: externalUrl ? url : undefined,
          to: !externalUrl ? url : undefined,
          component: externalUrl || subLinks ? 'a' : Link,
        }}
        disableTouchRipple
        disableFocusRipple
        sx={styles.bottomBarItem}
        className={isActive ? 'active' : ''}
        color="ghost"
      >
        {label}
        {subLinks?.length && <KeyboardArrowIcon isOpen={!!anchorEl} />}
      </Button>
      {subLinks?.length && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
          sx={styles.bootomBarSubMenu}
          classes={{
            paper: 'bottom-bar-menu',
          }}
        >
          {subLinks.map((link) => (
            <MenuItem
              key={link.label}
              {...{
                href: link.externalUrl ? link.url : undefined,
                to: !link.externalUrl ? link.url : undefined,
                component: link.externalUrl ? 'a' : Link,
              }}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                if (link.onClick) link.onClick(e);
                handleClose();
              }}
              disableTouchRipple
            >
              {link.label}
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
};

export default BottomBarMenuItem;
